export function LinkPreview(props: { href: string }) {
  return <div class="bg-gray-800 border border-gray-700 rounded-lg p-2 break-all font-mono text-xs text-cyan-300">{props.href}</div>;
}
